export const _decreesmu = [
    {
        title: 'Decreto 0401 de 2020',
        contents: 'Por el cual se delimitan las áreas de desarrollo naranja (adns): "centro fundacional bga" y "manzana 68 clúster creativo y turístico metropolitano de Bucaramanga", se imparten lineamientos para su implementación y organización y se dictan otras disposiciones.',
        link: 'https://www.bucaramanga.gov.co/wp-content/uploads/2021/06/DECRETO-0401-DE-13-NOVIEMBRE-DE-2020.pdf'
    },
    {
        title: 'Decreto 0069 de 2015 ',
        contents: '"Por el cual se definen y reglamentan los procedimientos para el estudio y aprobación de los Planes de Implantación en el Municipio de Bucaramanga.',
        link: 'https://www.bucaramanga.gov.co/wp-content/uploads/2021/08/DEC-069-DE-2015.pdf'
    },
    {
        title: 'Acuerdo 011 de 2014 ',
        contents: 'Por el cual se adopta el Plan de Ordenamiento Territorial de segunda generación del Municipio de Bucaramanga 2014 - 2027.',
        link: 'https://versionantigua.bucaramanga.gov.co/la-ruta/download/acuerdo/POT-2014-2027.pdf'
    },
    {
        title: 'Decreto 078 de 2008 ',
        contents: 'Por el cual se compilan los Acuerdos 034 de 2000, 018 de 2002, 046 de 2003 y 046 de 2007 que conforman el Plan de Ordenamiento Territorial del Municipio de Bucaramanga.',
        link: 'https://www.bucaramanga.gov.co/wp-content/uploads/2021/08/DECRETO-078-DE-2008.pdf'
    },
    {
        title: 'Código de urbanismo del área metropolitana de Bucaramanga de 1992',
        contents: '',
        link: 'https://curaduria1bucaramanga.com/public_docs/OTHERS/CODIGO DE URBANISMO.pdf'
    }
]